import PurchaseOrderDetail from "./PurchaseOrderDetail";
import { useCallback, useState, useMemo, useEffect } from "react";
import RejectedBee from "../../../../assets/images/PenndingApproval/Rejected Bee.png";
import { useDispatch, useSelector } from "react-redux";
import { selectors as purchaseOrderSelectors } from "../../../../../redux/PurchaseOrder";
import { CONSTANTS } from "client/utils/constants";
import purchaseOrderOperation from "../../../../../redux/PurchaseOrder/operations";
import FleetProcessingDispatch from "Store/OrderManagement/FleetProcessing/FleetProcessingDispatch";
import { setFleetItemId } from "Store/AssetManagement/AssetNumber/AssetNumberAction";
import { selectors as userProfileSelectors } from "redux/UserProfile";
import { getGLAccountCodeSave, setGLAccountCodeSave } from "Store/FleetManagement/GLAccountCodes/GLAccountCodesAction";
import { getAssetItemStatusPurchaseOrder } from "Store/FleetManagement/AssetItemStatusPurchaseOrder/AssetItemStatusPurchaseOrderAction";
import moment from "moment";
import { setConsolidatedFleetPo, setFleetPo } from "Store/OrderManagement/FleetProcessing/FleetProcessingAction";

const PurchaseOrderDetailContainer = (props: any) => {
  const { isValidToCreatePO } = props
  const [PopupcontentPool, setPopupcontentPool] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
  });

  const {
    orderDetails,
    getUserDetails,
    fleetPo,
    isVehicleConsolidatedChecked,
    isManageEquipConsolidatedChecked,
    purchaseOrderStepperDataArr,
    isNonstandardConsolidatedChecked,
    eqClassCodeDropdownList,
    itemId,
    userDetails,
    glAccountCodes,
    glAccountCodeSave,
    consolidatedFleetPo
  }: any = useSelector((state: any) => ({
    orderDetails: purchaseOrderSelectors.getOrderDetail(state),
    getUserDetails: state.UserProfile.getUserDetails,
    fleetPo: state.FleetProcessingReducer.fleetPo,
    isVehicleConsolidatedChecked: state.FleetProcessingReducer.isVehicleConsolidatedChecked,
    isManageEquipConsolidatedChecked: state.FleetProcessingReducer.isManageEquipConsolidatedChecked,
    isNonstandardConsolidatedChecked: state.FleetProcessingReducer.isNonstandardConsolidatedChecked,
    purchaseOrderStepperDataArr: purchaseOrderSelectors.getPurchaseOrderStepperData(state),
    eqClassCodeDropdownList: purchaseOrderSelectors.getEqClassCodeDropdown(state),
    itemId: state.AssetNumber.itemId,
    userDetails: userProfileSelectors.getUserDetails(state),
    glAccountCodes: state.GLAccountCodesReducer.glAccountCodes,
    glAccountCodeSave: state.GLAccountCodesReducer.glAccountCodeSave,
    consolidatedFleetPo: state.FleetProcessingReducer.consolidatedFleetPo,
  }))

  const dispatch = useDispatch();
 
  const dispatchGetFleetPo = FleetProcessingDispatch.dispatchGetFleetPo(dispatch);
  const dispatchSetError = purchaseOrderOperation.dispatchSetError(dispatch);
  const dispatchStepperData = purchaseOrderOperation.dispatchSetPurchaseorderStepperData(dispatch);
  const dispatchChangeLogs = purchaseOrderOperation.dispatchChangeLogs(dispatch);
  const dispatchStepperDataArr = purchaseOrderOperation.dispatchSetPurchaseorderStepperInfo(dispatch);  
  const dispatchGetEqClassCodeDropdown = purchaseOrderOperation.dispatchGetEqClassCodeDropdown(dispatch);
  const dispatchGetConsolidatedFleetPo = FleetProcessingDispatch.dispatchGetConsolidatedFleetPo(dispatch);
  const hideDialogPool = useCallback(
    () => setPopupcontentPool({ ...PopupcontentPool, isDialogVisible: false }),
    []
  );

  const [checkedItemDetails, setCheckedItemDetails] = useState<any>([])
  const [glAccountCodesDropdownList, setGlAccountCodesDropdownList] = useState<any>([])
  const [alreadySelectedGlAccount, setAlreadySelectedGlAccount] = useState<any>({})
  const [hasFetchedEqClassCodeDropdown, setHasFetchedEqClassCodeDropdown] = useState<boolean>(false);

  const purchaseOrderStepperData = useMemo(() => {
    return purchaseOrderStepperDataArr?.length
      ? purchaseOrderStepperDataArr.find(
        (item: any) =>
          +item?.itemNumber === +String(props?.itemDetails?.itemId).split("-")[1]
      ) || {}
      : {};
  }, [purchaseOrderStepperDataArr]);

  useEffect(() => {
    const isNonStandardEquipment =
      purchaseOrderStepperData?.orderRequestType === CONSTANTS.NON_STANDARD_EQUIPMENT;
    if (isNonStandardEquipment && !hasFetchedEqClassCodeDropdown) {
      dispatchGetEqClassCodeDropdown();
      setHasFetchedEqClassCodeDropdown(true);
    }
  }, [purchaseOrderStepperData?.orderRequestType, hasFetchedEqClassCodeDropdown]);

  const popupOutlinebtnOnclickPool = () => {
    hideDialogPool();
  };

  useEffect(() => {
    const tempList = glAccountCodes?.map((item: any) =>
      ({ label: item.text, key: item.value, ...item })
    );
    setGlAccountCodesDropdownList(tempList);
  }, [glAccountCodes])

  const updateStepperDataArr = (fleetPODetails: any) => {
    let poDetailsArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr))
      let poData = checkedItemDetails?.map((val: any) => {
        return {
          ...val, 
          poNumber: fleetPODetails.poNumber,
          poCreationDate: fleetPODetails?.poCreatedDate,
          canCreatePoPdf: fleetPODetails?.canCreatePoPdf,
          poPdfUrl: null
        }
      })
      poDetailsArr?.forEach((item: any, index: any) => {
        poData?.map((val: any) => {
          if (item.itemId == val.itemId) {
            poDetailsArr[index] = val
          }
        })
      })
      dispatchStepperDataArr(poDetailsArr)
  }

  const popUpMessage = (errors: any) => {
    let decriptionTxt = errors
    setPopupcontentPool({
      ...PopupcontentPool,
      titleImg: RejectedBee,
      title: "",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "Close",
      isSingleConfirmationBtn: true,
    });
  }

  useEffect(() => {
    if (fleetPo?.poNumber && itemId == purchaseOrderStepperData.itemId) {
      updateStepperDataArr(fleetPo)
    }
    if (fleetPo?.errorMessages?.length > 0 && itemId == purchaseOrderStepperData.itemId) {
      let totalError = fleetPo?.errorMessages?.join(',');
      dispatchSetError({
        showAlert: true,
        type: "warning",
        text: totalError,
        itemNumber: +String(props?.itemDetails?.itemId).split("-")[1],
      });

      setTimeout(() => {
        dispatchSetError(undefined);
      }, 5000);
    }
    dispatch(setFleetPo(null))
  }, [fleetPo])

  useEffect(() => {
    if (consolidatedFleetPo?.poNumber && itemId == purchaseOrderStepperData.itemId) {
      updateStepperDataArr(consolidatedFleetPo)
    }
    if (consolidatedFleetPo?.errorMessages?.length > 0 && itemId == purchaseOrderStepperData.itemId) {
      let totalError = consolidatedFleetPo?.errorMessages?.join(',');
      popUpMessage(totalError)
    dispatch(setConsolidatedFleetPo(null))
    }
  }, [consolidatedFleetPo])

  const lineItems = (item: any) => {
    return {
      desc1: item?.poDescription1,
      desc2: item?.poDescription2 ? item?.poDescription2 : "",
      price: item?.poPricePerUnit ? item?.poPricePerUnit : 0,
      glAccount: props.purchaseOrderStepperData.glaccountNumber ?? "",
      assetNumber: item?.assetNumber ? item?.assetNumber.toString() : "",
      isPrePaid: false,
      prepaidAmount: 0,
      modelID: item?.assetModelId ? item?.assetModelId : 0,
      requestItemNo: item?.itemNumber ? item?.itemNumber : 0,
      estDeliveryDate: item?.estDeliveryDate ? item?.estDeliveryDate : moment().add(15, 'd').toDate()
    }
  }

  const createPoDetails = (saveConsolidatedPoData: any, itemDetails: any) => {
    let poCreationDetails = {
      orderId: orderDetails?.orderRequestId,
      itemNumber: itemDetails?.itemNumber,
      vendorNumber: itemDetails?.isVendorSameAsDealer ?  itemDetails?.poDealerDetails?.vendorABNumber : itemDetails?.poVendorDetails?.vendorAbNumber,
      isConsolidatedPO: false,
      lineItems: JSON.parse(JSON.stringify(saveConsolidatedPoData)),
      savedBy: getUserDetails?.emailId
    }
    dispatchGetFleetPo(poCreationDetails);
  }

  const createConsolidatedPO = (requestItems: any) =>{
    const payload = {
    orderId: orderDetails?.orderRequestId,
    itemNumber: props?.itemDetails?.itemNumber,
    vendorNumber: props?.itemDetails?.isVendorSameAsDealer ?  props?.itemDetails?.poDealerDetails?.vendorABNumber : props?.itemDetails?.poVendorDetails?.vendorAbNumber,
    isConsolidatedPO: true,
    savedBy: getUserDetails?.emailId,
    requestItems: requestItems
    }
    dispatchGetConsolidatedFleetPo(payload)
  }

  const createPOClick = () => {
    dispatch(setFleetItemId(purchaseOrderStepperData.itemId))

    if (!props.purchaseOrderStepperData.poDescription1) {
      props.setErrors({
        ...props?.errors,
        poDescription1: !purchaseOrderStepperData.poDescription1,
      });
      return;
    } else if (props.purchaseOrderStepperData.poDescription1?.length > 30) {
      props.setErrors({
        ...props?.errors,
        poDescription1: 'length-30',
      });
      return;
    } else if (props.purchaseOrderStepperData.poDescription2?.length > 30) {
      props.setErrors({
        ...props?.errors,
        poDescription2: 'length-30',
      });
      return;
    } else if (!props.purchaseOrderStepperData.glaccountNumber) {
      props.setErrors({
        ...props?.errors,
        glaccountNumber: !purchaseOrderStepperData.glaccountNumber,
      });
      return;
    }
    const isValidToCreate = isValidToCreatePO()
    if (isValidToCreate) {
      const saveConsolidatedPoDataArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr));
      const saveConsolidatedPoData: any = []
      const ConsolidatedPoData: any = []

      if (isVehicleConsolidatedChecked === props.itemDetails?.orderRequestType) {
        saveConsolidatedPoDataArr?.map((item: any) => {
          if (item?.orderRequestType === CONSTANTS.VEHICLE_REQUEST && !item?.pocipDetails && !item.poNumber && !item.poNumber && item?.itemStatus !== CONSTANTS.ORDER_STATUS.CANCELLED) {
            ConsolidatedPoData.push(item)
            setCheckedItemDetails(ConsolidatedPoData)
            let items = lineItems(item)
            saveConsolidatedPoData.push(items)
          }
        })
        createConsolidatedPO(saveConsolidatedPoData?.map((item: any) => item?.requestItemNo))
      }
      else if (isManageEquipConsolidatedChecked === props.itemDetails?.orderRequestType) {
        saveConsolidatedPoDataArr?.map((item: any) => {
          if (item?.orderRequestType === CONSTANTS.MANAGED_EQUIPMENT && !item?.pocipDetails && !item.poNumber && !item.poNumber && item?.itemStatus !== CONSTANTS.ORDER_STATUS.CANCELLED) {

            ConsolidatedPoData.push(item)
            setCheckedItemDetails(ConsolidatedPoData)
            let items = lineItems(item)
            saveConsolidatedPoData.push(items)
          }
        })

        createConsolidatedPO(saveConsolidatedPoData?.map((item: any) => item?.requestItemNo))
      }
      else if (isNonstandardConsolidatedChecked === props.itemDetails?.orderRequestType) {
        saveConsolidatedPoDataArr?.map((item: any) => {
          if (item?.orderRequestType === CONSTANTS.NON_STANDARD_EQUIPMENT && !item?.pocipDetails && !item.poNumber && !item.poNumber && item?.itemStatus !== CONSTANTS.ORDER_STATUS.CANCELLED) {

            ConsolidatedPoData.push(item)
            setCheckedItemDetails(ConsolidatedPoData)
            let items = lineItems(item)
            saveConsolidatedPoData.push(items)
          }
        })
        createConsolidatedPO(saveConsolidatedPoData?.map((item: any) => item?.requestItemNo))
      }
      else {
        ConsolidatedPoData.push(JSON.parse(JSON.stringify(props?.itemDetails)))
        setCheckedItemDetails(ConsolidatedPoData)
        let items = lineItems(props?.itemDetails)
        saveConsolidatedPoData.push(items)
        createPoDetails(saveConsolidatedPoData, props.itemDetails)
      }
    }
    else {
      dispatchSetError({
        showAlert: true,
        type: "warning",
        text: "Please save this order before continue order further.",
        itemNumber: +String(props?.itemDetails?.itemId).split("-")[1],
      });

      setTimeout(() => {
        dispatchSetError(undefined);
      }, 5000);
    }

    
  };

  useEffect(() => {
    if (glAccountCodeSave && glAccountCodeSave != null && alreadySelectedGlAccount?.fleetRequestDetailId == purchaseOrderStepperData?.fleetRequestDetailId) {
      dispatchChangeLogs(alreadySelectedGlAccount?.fleetRequestDetailId)
      dispatch(setGLAccountCodeSave(null))
      dispatch(getAssetItemStatusPurchaseOrder(alreadySelectedGlAccount?.fleetRequestDetailId))
    } else if (!glAccountCodeSave && glAccountCodeSave != null && alreadySelectedGlAccount?.fleetRequestDetailId == purchaseOrderStepperData?.fleetRequestDetailId) {
      const purchaseOrderData = {
        ...props.purchaseOrderStepperData,
        glaccountNumber: alreadySelectedGlAccount
      };
      dispatchStepperData(purchaseOrderData);
    }
  }, [glAccountCodeSave])

  const onChangeGLAccountCode = (selectedItem: any) => {
    let glNumber = orderDetails?.poDetails?.find((item?: any) => item?.fleetRequestDetailId == purchaseOrderStepperData?.fleetRequestDetailId)
    setAlreadySelectedGlAccount({glaccountNumber: glNumber?.glaccountNumber, fleetRequestDetailId: purchaseOrderStepperData?.fleetRequestDetailId})
    let payLoad : any = {
      fleetDetailId: purchaseOrderStepperData?.fleetRequestDetailId,
      savedBy: userDetails?.emailId ,
      glAccountNumber: selectedItem.value
    } 
    dispatch(getGLAccountCodeSave(payLoad))
    const purchaseOrderData = {
      ...props.purchaseOrderStepperData,
      glaccountNumber: selectedItem.value
    };
    props.setErrors({
      ...props?.errors,
      glaccountNumber: false,
    });
    dispatchStepperData(purchaseOrderData);
  }
    
  const onChangeBarCode = (event: any) => {
    const purchaseOrderData = {
      ...props.purchaseOrderStepperData,
      barcodeNo: event.target.value,
    };
    props.setErrors({
      ...props?.errors,
      barcodeNo: event.target.value.length > 50,
    });
    dispatchStepperData(purchaseOrderData);
    const tempPurchaseStepperArr = JSON.parse(JSON.stringify(purchaseOrderStepperDataArr))?.map((item: any) => {
      if(item?.fleetRequestDetailId === purchaseOrderData?.fleetRequestDetailId){
        return {
          ...purchaseOrderData,
          isPurchaseOrderSave : false
        }
      }
      return item
    })
    dispatchStepperDataArr(tempPurchaseStepperArr)
  }

  const onChangeEqClassCode = (selectedItem: any) => {
    const purchaseOrderData = {
      ...props.purchaseOrderStepperData,
      eqClassCode: selectedItem?.value ?? null,
      eqClassDescription: selectedItem?.description ?? null,
    };

    dispatchStepperData(purchaseOrderData);

    const tempPurchaseStepperArr = JSON.parse(
      JSON.stringify(purchaseOrderStepperDataArr)
    )?.map((item: any) => {
      if (item?.fleetRequestDetailId === purchaseOrderData?.fleetRequestDetailId) {
        return {
          ...purchaseOrderData,
          isPurchaseOrderSave: false,
        };
      }
      return item;
    });

    dispatchStepperDataArr(tempPurchaseStepperArr);
  };

  return (
    <PurchaseOrderDetail
      createPOClick={createPOClick}
      popupOutlinebtnOnclickPool={popupOutlinebtnOnclickPool}
      hideDialogPool={hideDialogPool}
      PopupcontentPool={PopupcontentPool}
      handleClickCancel={props.handleClickCancel}
      Popupcontent={props.Popupcontent}
      popupOutlinebtnOnclick={props.popupOutlinebtnOnclick}
      hideDialog={props.onDismiss}
      popupPrimarybtnOnclick={props.popupPrimarybtnOnclick}
      handleChange={props.handleChange}
      onChangeGLAccountCode={onChangeGLAccountCode}
      onChangeBarCode={onChangeBarCode}
      onChangeEqClassCode={onChangeEqClassCode}
      onBlurBarcode={props?.onBlurBarcode}
      purchaseOrderStepperData={props.purchaseOrderStepperData}
      updateValue={props.updateValue}
      savePurchaseOrder={props.savePurchaseOrder}
      errors={props.errors}
      isCompleted={props.isCompleted}
      glAccountCodesDropdownList={glAccountCodesDropdownList}
      eqClassCodeDropdownList={eqClassCodeDropdownList}
    />
  );
};

export default PurchaseOrderDetailContainer;
